// Popup Maker: 150px スクロール + フッター外で表示、条件外で非表示
const POPUP_ID = 752;

let isPopupOpen = false;

const FOOTER_HIDE_OFFSET = 200;

function isFooterInView() {
	const footer = document.querySelector('.l-footer');
	if (!footer) return false;
	return footer.getBoundingClientRect().top < window.innerHeight + FOOTER_HIDE_OFFSET;
}

function handlePopupScroll() {
	if (typeof PUM === 'undefined') return;

	const scrollTop = window.scrollY;
	const threshold = 150;
	const shouldShow = scrollTop >= threshold && !isFooterInView();

	if (shouldShow && !isPopupOpen) {
		PUM.open(POPUP_ID);
		isPopupOpen = true;
	} else if (!shouldShow && isPopupOpen) {
		PUM.close(POPUP_ID);
		isPopupOpen = false;
	}
}

document.addEventListener('pumAfterClose', function (e) {
	if (e.target && e.target.id === 'pum-' + POPUP_ID) {
		isPopupOpen = false;
	}
});

handlePopupScroll();
window.addEventListener('scroll', handlePopupScroll);
